import React, { Fragment, useContext } from "react";
import classes from "./App.module.css";
import { Route, Switch } from "react-router";
import { useHistory } from "react-router-dom";

import background from "./assets/background.jpg";

import { NavBar, NavBarGlob } from "./components/Header/NavBar";
import Gallery from "./pages/Gallery";
import Selfie from "./pages/Selfie";
import Materials from "./pages/Materials";
import Products from "./pages/Products";
import CountryDetails from "./pages/CountryDetails";
import Contact from "./components/Contact/Contact";
import ProjectInfo from "./components/Articles/ProjectInfo";

import Country from "./components/Country/Country";
import PolandContext from "./store/poland-context";
import GermanyContext from "./store/germany-context";
import CroatiaContext from "./store/croatia-context";
import GalleryContext from "./store/gallery-context";
import GlobContext from "./store/glob-context";
import MainPage from "./pages/MainPage";
import FloatingButton from "./components/UI/FloatingButton";
import Card from "./components/UI/Card";
import Article from "./components/Articles/Article";

import logo from "./assets/logo.png";
import logoG from "./assets/logo3-3.png";

function App() {
  const history = useHistory();
  const polCtx = useContext(PolandContext);
  const gerCtx = useContext(GermanyContext);
  const croCtx = useContext(CroatiaContext);
  const galleryCtx = useContext(GalleryContext);
  const globCtx = useContext(GlobContext);

  const countriesCtx = [polCtx, gerCtx, croCtx];
  const countriesContent = countriesCtx.map((ctx) => (
    <Country
      key={ctx.id}
      id={ctx.id}
      title={ctx.title}
      website={ctx.website}
      photo={ctx.photo}
      text={ctx.mainText}
      activities={ctx.activities}
      meeting={ctx.meeting}
    />
  ));

  const onEjsHandler = () => {
    history.push("/ejs");
  };
  const onGlobHandler = () => {
    history.push("/glob");
  };

  return (
    <Fragment>
      <Switch>
        <Route path="/" exact>
          <MainPage onEjs={onEjsHandler} onGlob={onGlobHandler} />
        </Route>
        <Route path="/ejs" exact>
          <NavBar />
          <FloatingButton />
          <div className={classes.mainImg} id="main">
            <img src={background} alt="background" />
          </div>
          {countriesContent}
          <ProjectInfo />
          <Contact
            proj_code="2019-1-PL01-KA229-065637"
            phones={["+48 17 277 27 37", "+49 28 31 84 95", "+385 1 6671 733"]}
            emails={[
              "zsbabica@czudec.pl",
              "schule@lmg-geldern.de",
              "os.zagreb.098@gmail.com",
            ]}
            location={[
              "Babica Location",
              "Geldern Location",
              "Zagreb Location",
            ]}
            map_link={[
              "https://goo.gl/maps/8XJE4SphK7XHEK39A",
              "https://goo.gl/maps/YbDgJE5ZNTVyhRCV9",
              "https://goo.gl/maps/ruZ2ycdypWhEs1wj8",
            ]}
            image={logo}
            color="dark"
          />
        </Route>

        <Route path="/glob" exact>
          <NavBarGlob />
          <FloatingButton />
          <div id="main"></div>
          <Card>
            <Article
              header={globCtx.mainPage.info.header}
              text={globCtx.mainPage.info.text}
            />
          </Card>
          <Card>
            <Article
              header={globCtx.mainPage.infoMalta.header}
              text={globCtx.mainPage.infoMalta.text}
              photos={globCtx.mainPage.infoMalta.photos.mainInfoPhotos}
              comment={globCtx.mainPage.infoMalta.photos.mainInfoPhotosComment}
            />
          </Card>
          <Card>
            <Article header={"Szkolenie na Krecie"} />
            <Article text={globCtx.mainPage.infoGreece.text} />
            <div className={classes.frame}>
              <iframe
                className={classes.iframe}
                title="kretaPage"
                width="100%"
                height="100%"
                src="https://mlodzipologlocisimplythebest.weebly.com"
              ></iframe>
            </div>
          </Card>
          <Card>
            <Article
              header="Job shadowing w Wiedniu"
              text={globCtx.mainPage.infoAustria.text}
              photos={globCtx.mainPage.infoAustria.photos}
            />
          </Card>
          <Contact
            proj_code="2020-1-PL01-KA101-078463"
            phones={["+43 1 8151407", "+356 2379 6321", "+30 281 039 3229"]}
            emails={[
              "direktion.912051@schule.wien.gv.at",
              "info@etimalta.com",
              "webmaster@uoc.gr",
            ]}
            location={[
              "Lokalizacja - Austria",
              "Lokalizacja - Malta",
              "Lokalizacja - Kreta",
            ]}
            map_link={[
              "https://goo.gl/maps/kEC1hH2TTUQVn4V19",
              "https://g.page/ETIMALTA?share",
              "https://goo.gl/maps/Bodas9RDEb2ZxNFz5",
            ]}
            image={logoG}
            name="Kontakt"
          />
        </Route>

        <Route path="/gallery">
          <NavBar />
          <Gallery photos={galleryCtx} />
        </Route>
        <Route path="/country/:countryId/:id">
          <NavBar />
          <CountryDetails />
        </Route>
        <Route path="/materials">
          <NavBar />
          <Materials />
        </Route>
        <Route path="/selfie">
          <NavBar />
          <Selfie />
        </Route>
        <Route path="/products">
          <NavBarGlob />
          <Products />
        </Route>
      </Switch>
    </Fragment>
  );
}

export default App;
